import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StarIcon } from '@/features/notes/icons';
import { notesApi } from '@/api/notes';
import { errorMessage } from '@/api/client';

export function TemplateToggleButton({
  noteId,
  isTemplate,
  ownerId,
  currentUserId,
  onChanged,
}: {
  noteId: string;
  isTemplate: boolean;
  ownerId: string;
  currentUserId: string;
  onChanged: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const { t } = useTranslation();

  if (ownerId !== currentUserId) return null; // Doar owner-ul poate marca

  const toggle = async () => {
    setBusy(true);
    setErr(null);
    try {
      await notesApi.setTemplate(noteId, !isTemplate);
      onChanged();
    } catch (e) {
      setErr(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn-outline text-sm inline-flex items-center gap-1.5"
        style={
          isTemplate
            ? { color: 'var(--c-amber)', borderColor: 'var(--c-amber)' }
            : undefined
        }
        onClick={toggle}
        disabled={busy}
        title={
          isTemplate
            ? t('notes_ui.editor.template_unmark_title')
            : t('notes_ui.editor.template_mark_title')
        }
      >
        <StarIcon className="w-3.5 h-3.5" filled={isTemplate} />
        {t('notes_ui.editor.template_button')}
      </button>
      {err && (
        <span className="text-[10px]" style={{ color: 'var(--danger)' }}>
          {err}
        </span>
      )}
    </>
  );
}
